
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import WorkoutTable from "./WorkoutTable";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProgramDetailsContentProps {
  programData: any;
  loading: boolean;
  programId?: string;
}

export function ProgramDetailsContent({
  programData,
  loading,
  programId
}: ProgramDetailsContentProps) {
  const handleRefresh = () => {
    window.location.reload();
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-white text-center p-10">
          <h2 className="text-2xl font-semibold mb-4">Loading program...</h2>
          <Skeleton className="h-4 w-3/4 mx-auto mb-2 bg-white/10" />
          <Skeleton className="h-4 w-1/2 mx-auto bg-white/10" />
        </div>
      </div>
    );
  }

  // Add debugging information when there's no program data
  if (!programData || (typeof programData === 'object' && Object.keys(programData).length === 0)) {
    return (
      <div className="flex flex-col h-full">
        <div className="text-white p-6 bg-white/5 rounded-lg border border-white/10">
          <div className="flex items-center gap-2 mb-4 text-amber-300">
            <AlertCircle className="h-5 w-5" />
            <h3 className="font-medium">No Program Data Available</h3>
          </div>
          <p className="mb-4">
            This program doesn't have any workout data yet. This could be because:
          </p>
          <ul className="list-disc pl-5 space-y-2 text-white/80">
            <li>The program is still being generated</li>
            <li>There was an issue with data retrieval due to permissions</li>
            <li>The program hasn't been fully created yet</li>
          </ul>
          <div className="mt-6 text-sm text-white/60">
            Program ID: {programId || programData?.id || "Not available"}
          </div>
          <div className="mt-4">
            <Button 
              variant="outline" 
              className="bg-white/10 hover:bg-white/20 text-white"
              onClick={handleRefresh}
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Refresh Page
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="text-white">
        <WorkoutTable />
      </div>
    </div>
  );
}
